import * as React from 'react';
import { Fragment, useContext, useRef, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { SearchIcon, XIcon } from 'lucide-react';
import ChatBotMenuComponent from './chatBotComponent/ChatBotMenuComponent';
import { AppAgentContext } from '../../../context/ContextProvider';
import useHighlight from '../../../hooks/useHighlight';
import { AIInstruction } from '../../../types/Session';
import { ChatRefComponent } from './chatBotComponent/ChatBotComponent';
import { useTranslate } from 'sbx-crm-menu-ui';

type Props = {
    className?: string;
    transcription: string
    sessionId: string
    chatBotRef: React.RefObject<ChatRefComponent>
};
const baseOptionsToBot: AIInstruction[] = [
    {
        label: 'Preguntar al Asistente digital',
        instruction: 'En una conversación con el cliente debemos responder a la siguiente pregunta:',
    },
];

const TranscriptionComponent = ({ className = '', transcription, chatBotRef, sessionId }: Props) => {
    const { state: { session } } = useContext(AppAgentContext);
    const { t: common } = useTranslate('common');
    const { t: speech } = useTranslate('speech');
    const { selectionText, setSelectionText, handleMouseUp } = useHighlight();
    const [searchTerm, setSearchTerm] = useState<string>('');
    const transcriptionRef = useRef<HTMLDivElement>(null);
    const [isSearchActive, setIsSearchActive] = useState<boolean>(false);

    const handleSearch = () => {
        if (transcriptionRef.current) {
            const regex = new RegExp(searchTerm, 'gi');
            const text = transcriptionRef.current.innerHTML;
            transcriptionRef.current.innerHTML = text.replace(regex, match => `<mark>${match}</mark>`);
            setIsSearchActive(true);
        }
    };

    const handleClearSearch = () => {
        if (transcriptionRef.current) {
            transcriptionRef.current.innerHTML = transcription.split('\n').map(line =>
                line.trim() ? `<p>${line}</p>` : '<br>',
            ).join('');
            setSearchTerm('');
            setIsSearchActive(false);
        }
    };

    return (
        <Card className={className}>
            <CardHeader>

                <CardTitle>{speech('transcription')}</CardTitle>
                <div className="flex space-x-2">
                    <Input
                        type="text"
                        placeholder={common('search')}
                        className="border-gray-400 rounded"
                        value={searchTerm}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                    />
                    <Button onClick={handleSearch} className="!bg-black !text-white rounded"
                            disabled={!transcription}>
                        <SearchIcon className="mr-2 h-4 w-4" />
                        {common('search')}
                    </Button>

                    <Button onClick={handleClearSearch} className="rounded border-gray-400"
                            disabled={!isSearchActive} variant="outline">
                        <XIcon className="mr-2 h-4 w-4" />
                        {`${common('clear')}`}
                    </Button>
                </div>
            </CardHeader>
            <CardContent>
                <ChatBotMenuComponent
                    sessionId={sessionId}
                    onClose={() => {
                        // setSelectionText('')
                    }}
                    optionsToBot={session?.ai_agent_config?.chat?.sbx_ai_bot_options?.agent_to_bot ?? baseOptionsToBot}
                    askToBot={(instruction) => {
                        if (chatBotRef.current) {
                            chatBotRef.current.sendMessage(`${instruction}  ${selectionText}`);
                        }
                        setSelectionText('');
                    }}
                    showMenu={selectionText.length > 0}
                    selectionText={selectionText} />
                <div
                    ref={transcriptionRef}
                    onMouseUp={handleMouseUp}
                    className="h-64 2xl:h-[50vh] overflow-y-auto p-4 bg-muted rounded-lg"
                >


                    {transcription ?
                        transcription.split('\n').map((line, index) => (
                            <Fragment key={index}>
                                {line}
                                <br />
                            </Fragment>
                        )) :
                        speech('transcription_description')
                    }
                </div>
            </CardContent>
        </Card>
    );
};

export default TranscriptionComponent;